import type { RouteObject } from "react-router-dom";
import type { FeatureFlags } from "../lib/store/featureFlagStore";
import { abacusRoutes } from "./abacus";
import { adminRoute } from "./admin";
import {
	coreRoutes,
	curiosityRoutes,
	curiosityV2Routes,
	searchRoutes,
} from "./core";
import { developmentRoutes } from "./development";
import { errorRoutes } from "./error";
import { galileoRoutes } from "./galileo";
import { howToRoutes } from "./howto";

export { ROUTES } from "./constants";

export const buildRoutes = (flags: FeatureFlags): RouteObject[] => [
	...coreRoutes,
	...(flags.elastic_search ? searchRoutes : []),
	...(flags.curiosity ? curiosityRoutes : []),
	...(flags.curiosity ? curiosityV2Routes : []),
	...galileoRoutes,
	...(flags.abacus ? abacusRoutes : []),
	...(flags.how_to ? howToRoutes : []),
	adminRoute,
	...developmentRoutes,
	...errorRoutes,
];
